import Vue from "vue";

const requireAll = context => context.keys().map(context);

const components = require.context(
  // 其组件目录的相对路径
  "./",
  // 是否查询其子目录
  false,
  // 匹配基础组件文件名的正则表达式
  /\.vue$/
);

// 注册组件，组件名格式为ss-*
requireAll(components).forEach(item => {
  const component = item.default;
  const name = component.name.replace(/([A-Z])/g, "-$1").toLowerCase();
  Vue.component(`emp${name}`, component);
});
